export function getOtherCategoryNames() {
  var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var name = arguments.length > 1 ? arguments[1] : undefined;
  return categories.filter(function (_ref) {
    var categoryName = _ref.name;
    return categoryName !== name;
  }).map(function (_ref2) {
    var categoryName = _ref2.name;
    return categoryName;
  });
}